import { useViewport } from '@chilecompra/react-kit'
import { Button, Table, TableRow, Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'

import { PUBLIC_URL } from '../../../config/settings/environment.config'
import { Container, SuccessIcon, TableCell, TableContainer } from '../Cfmp.styles'

const rows = ({ cfmp }) => [
  { label: 'Nombre del proceso', value: 'Registro de Compra Fuera de Mercado Público' },
  {
    label: 'Causal de Compra Fuera de Mercado Público',
    value: cfmp.reason || '-'
  },
  { label: 'Monto total', value: cfmp.amount || '-' },
  {
    label: 'Proveedor',
    value: (
      <>
        <Typography variant="body2">{cfmp.supplier || '-'}</Typography>

        <Typography color="black3" margin="4px 0 0" variant="body2">
          RUT: {cfmp.rut || '-'}
        </Typography>
      </>
    )
  },

  { isLast: true, label: 'Fecha de creación', value: cfmp.createdAt || '-' }
]

/**
 * The CfmpSuccess component.
 */
export const CfmpSuccess = ({ cfmp, onResetCfmp }) => {
  const { size } = useViewport()

  return (
    <Container alignItems="center" direction="column" spacing={4}>
      <SuccessIcon alt="Success icon" src={`${PUBLIC_URL}/assets/icons/circle-success.svg`} />

      <Container alignItems="center" direction="column" spacing={2}>
        <Typography fontWeight="bold" style={{ textAlign: 'center' }} variant="h2">
          Compra fuera de Mercado Público registrada con éxito
        </Typography>

        <Typography color="success" fontWeight="bold" variant="h3">
          Número: {cfmp.code || '-'}
        </Typography>
      </Container>

      <TableContainer>
        <Table accessibility={{ label: 'Resumen de la compra fuera de Mercado Público' }}>
          {rows({ cfmp }).map(({ isLast, label, value }) => (
            <TableRow key={label}>
              <TableCell
                className="cellHeader"
                disableBottomBorder={isLast}
                padding="16px"
                width="180px"
              >
                <Typography fontWeight="bold" variant="body2">
                  {label}
                </Typography>
              </TableCell>

              <TableCell disableBottomBorder={isLast} padding="16px">
                {typeof value === 'string' ? (
                  <Typography variant="body2">{value}</Typography>
                ) : (
                  value
                )}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>

      <Button
        onClick={onResetCfmp}
        padding="0 16px"
        variant="text"
        width={size.isTiny ? '100%' : '300px'}
      >
        Volver al inicio del módulo
      </Button>
    </Container>
  )
}

CfmpSuccess.propTypes = {
  cfmp: PropTypes.object.isRequired,
  onResetCfmp: PropTypes.func.isRequired
}
